import { Button } from "@faire/slate/components/button";
import { SelectionCardGroup } from "@faire/slate/components/selection-card";
import { useState } from "react";

import { RetailerMobileNav } from "./RetailerMobileNav";

type ResolutionOption = "replace" | "refund";

type ResolutionScreenProps = {
  onContinue?: () => void;
  onBack?: () => void;
  progressFraction?: number;
};

export const ResolutionScreen = ({
  onContinue,
  onBack,
  progressFraction = 0.25,
}: ResolutionScreenProps) => {
  const [resolution, setResolution] = useState<ResolutionOption>("replace");

  return (
    <div className="bg-fs-surface-primary flex min-h-full flex-col">
      <RetailerMobileNav progressFraction={progressFraction} onBack={onBack} />
      <div className="flex flex-1 flex-col px-(--slate-spacing-section-medium) pt-(--slate-spacing-section-medium) pb-(--slate-spacing-section-large)">
        <h1 className="type-fs-page-heading text-fs-text-primary mb-(--slate-dimensions-4)">
          How would you like to resolve this?
        </h1>
        <div className="flex flex-col gap-(--slate-dimensions-2)">
          <SelectionCardGroup
            name="retailer-resolution"
            items={[
              {
                label: "Replace items",
                description:
                  "A replacement order will be sent once accepted by the brand",
                checked: resolution === "replace",
                onChange: () => setResolution("replace"),
              },
              {
                label: "Get a refund",
                description: "Affected items will be removed from your invoice",
                checked: resolution === "refund",
                onChange: () => setResolution("refund"),
              },
            ]}
          />
        </div>
      </div>
      <div className="bg-fs-surface-primary sticky bottom-0 px-(--slate-spacing-section-medium) pt-(--slate-dimensions-2) pb-(--slate-spacing-section-medium)">
        <Button variant="primary" fullWidth onClick={onContinue}>
          Continue
        </Button>
      </div>
    </div>
  );
};
